export const WeixinShare = {
    create: function (userInfo, shareData) {

        window.H.post("/app/wechath5/sign", { "url": window.location.href }, function (res) {
            WeixinShare.config(res, userInfo, shareData);
        });
    },

    isClose: false,
    config: function (res, userInfo, shareData) {
        // let userInfo = localStorage.getItem('userInfoH5') ? JSON.parse(localStorage.getItem('userInfoH5')) : {}
        let normalConfig = {
            shareName: userInfo.nickname + '的分享',// => 名称
            shareImg: "http://" + location.host + "/img/logo.png", // => logo
            shareMs: '专政策通——通达所有政策',//描述
            linkNow: "http://" + location.host + "/codeBase.html?parent_id=" + userInfo.id  //这个链接为，分享出去之后，用户访问的地址
        }
        shareData = Object.assign(normalConfig, shareData)

        WeixinShare['data'] = {
            title: shareData.shareName,
            desc: shareData.shareMs,
            link: shareData.linkNow,// 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareData.shareImg,// 分享图标
        }
        console.log(WeixinShare.data)
        
        wx.ready(function () {
            wx.updateAppMessageShareData(WeixinShare.data);
            //wx.onMenuShareQQ(Weixin.data);
            wx.updateTimelineShareData(WeixinShare.data);

        });
        //res.result.debug=true
        res.result.jsApiList = [

            'checkJsApi',
            'updateTimelineShareData',
            'updateAppMessageShareData',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onRecordEnd',
            'playVoice',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'

        ];
        // res.result.debug = true; // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
        wx.config(res.result);
    },

}